<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ quoteIcon }}</md-icon>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-form-label">Search:</label>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-input
                    type="search"
                    clearable
                    placeholder="e.g. site name, building name/address or serial no"
                    v-model="searchCriteria.searchText"
                    @keydown.enter.native="searchQuotes()"
                  ></md-input>
                  <md-button
                    class="md-icon-button md-primary"
                    @click="searchQuotes()"
                  >
                    <md-icon>search</md-icon>
                  </md-button>
                </md-field>
              </div>
            </div>
            <md-table
              v-model="quotes.items"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Status">
                  <Badge :type="quoteStatus(item.quoteStatus).colour">{{
                    quoteStatus(item.quoteStatus).name
                  }}</Badge>
                </md-table-cell>
                <md-table-cell md-label="Priority">
                  {{ quotePriority(item.quotePriority).name }}
                </md-table-cell>
                <md-table-cell md-label="Type">
                  {{ quoteType(item.quoteType).name }}
                </md-table-cell>
                <md-table-cell md-label="Date">
                  {{ item.lastUpdatedDate | moment("DD-MMM-YYYY") }}
                </md-table-cell>
                <md-table-cell md-label="Value">
                  &#163;{{ item.value }}
                </md-table-cell>
                <md-table-cell md-label="Serial No.">
                  {{ item.serialNo }}
                </md-table-cell>
                <md-table-cell md-label="Site Name">
                  {{ item.siteName }}
                </md-table-cell>
                <md-table-cell md-label="Description">
                  {{ item.description }}
                </md-table-cell>
                <md-table-cell class="text-right">
                  <md-button
                    class="md-just-icon md-primary"
                    @click="viewItem(item)"
                  >
                    <md-tooltip>View Quote</md-tooltip>
                    <md-icon>forward</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                md-label="No Quotes Found"
              ></md-table-empty-state>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} Quotes
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-default"
              v-model="searchCriteria.currentPage"
              :per-page="searchCriteria.itemsPerPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>find_in_page</md-icon>
            </div>
            <h4 class="title">Filters</h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label for="type">Type</label
              ><md-select
                v-model="filterCriteria.quoteTypeId"
                name="type"
                id="type"
                @md-selected="onFilterChange"
              >
                <md-option :value="0">All</md-option>
                <md-option
                  v-for="type in permittedQuoteTypes"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.name }}
                </md-option>
              </md-select>
            </md-field>
            <md-field>
              <label for="status">Status</label
              ><md-select
                v-model="filterCriteria.quoteStatusId"
                name="status"
                id="status"
                @md-selected="onFilterChange"
              >
                <md-option :value="0">All</md-option>
                <md-option
                  v-for="status in permittedQuoteStatuses"
                  :key="status.id"
                  :value="status.id"
                >
                  {{ status.name }}
                </md-option>
              </md-select>
            </md-field>
            <md-field>
              <label for="priority">Priority</label
              ><md-select
                v-model="filterCriteria.quotePriorityId"
                name="priority"
                id="priority"
                @md-selected="onFilterChange"
              >
                <md-option :value="-1">All</md-option>
                <md-option
                  v-for="priority in permittedQuotePriorities"
                  :key="priority.id"
                  :value="priority.id"
                >
                  {{ priority.name }}
                </md-option>
              </md-select>
            </md-field>
            <md-field v-if="showPlantState()">
              <label for="plantState">Plant State</label>
              <md-select
                v-model="filterCriteria.plantState"
                name="plantState"
                id="plantState"
                @md-selected="onFilterChange"
              >
                <md-option :value="1">Active</md-option>
                <md-option :value="2">Archived</md-option>
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Pagination, Badge } from "@/components";

export default {
  components: {
    Pagination,
    Badge
  },
  data() {
    return {
      filterCriteria: {
        quoteTypeId: 0,
        quoteStatusId: 0,
        quotePriorityId: -1,
        quoteGroup: "rejected",
        plantState: 1
      },
      searchCriteria: {
        searchText: undefined,
        currentPage: 1,
        itemsPerPage: 15
      }
    };
  },
  async created() {
    await this.getQuotes();
  },
  computed: {
    ...mapGetters({
      globalClient: "globalClient",
      globalContractor: "globalContractor",
      quoteIcon: "quote/icon",
      quotes: "quote/quotes",
      quoteStatus: "quote/getQuoteStatus",
      permittedQuoteStatuses: "quote/getListOfRejectedQuoteStatuses",
      permittedQuoteTypes: "quote/getListOfQuoteTypes",
      permittedQuotePriorities: "quote/getListOfQuotePriorities",
      quoteType: "quote/getQuoteType",
      quotePriority: "quote/getQuotePriority"
    }),
    to() {
      let highBound = this.from + this.searchCriteria.itemsPerPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return (
        this.searchCriteria.itemsPerPage * (this.searchCriteria.currentPage - 1)
      );
    },
    total() {
      return this.quotes.total;
    }
  },
  methods: {
    async onFilterChange() {
      await this.getQuotes();
    },
    async searchQuotes() {
      await this.getQuotes();
    },
    async viewItem(item) {
      if (item.quoteType === 1) {
        this.viewQuote(item.id);
      } else {
        await this.viewStatInspItem(item.referenceId, item.referenceParentId);
      }
    },
    async viewQuote(id) {
      await this.$router.push({
        name: "Quote",
        params: { quoteId: id }
      });
    },
    async viewStatInspItem(id, statInspId) {
      await this.$router.push({
        name: "Stat Insp Item View",
        params: { statInspId: statInspId, statInspItemId: id },
        query: { fromQuote: true }
      });
    },
    async getQuotes() {
      this.$store.dispatch("quote/getQuoteListing", {
        clientId: this.globalClient.id,
        contractorRegionId: this.globalContractor.id,
        filterCriteria: this.filterCriteria,
        searchCriteria: this.searchCriteria
      });
    },
    addGeneralQuote() {
      this.$router.push({ name: "Add Quote" });
    },
    showPlantState() {
      return this.$auth.isInRole(4);
    }
  },
  watch: {
    async from() {
      await this.getQuotes();
    },
    async globalClient() {
      await this.getQuotes();
    },
    async globalContractor() {
      await this.getQuotes();
    }
  }
};
</script>

<style></style>
